export default {
    INVALID_DATA: 'Invalid crafting data, please submit a bug report.',
    INVALID_ITEM: 'Invalid item selected.',
    INVALID_ITEMS: 'You do not have the required items to craft that.',
    SELECT_ITEM: 'Please select an item to craft.',
    FAILED_CRAFT: 'You have failed to craft {{failedText}} '
} as const;
